module.exports = __webpack_public_path__ + "img/sintesis.3e8a8fbc.svg";